import React from 'react';
import Header from '../../../../components/layout/headers/Header';
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import BeneficiaryRequestsTable from './BeneficiaryRequestsTable';
import StorageHelper from '../../../../utils/storage-helper';

const BeneficiaryRequestsPage = () => {
    const userRoleObj = StorageHelper.get('userRole');
    const userRole = userRoleObj ? userRoleObj.name : '';
    const isAuthorized = ['ADMIN', 'UNDERWRITER', 'SUPER_ADMIN'].includes(userRole ? userRole.toUpperCase() : '');

    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    {isAuthorized ? (
                        <BeneficiaryRequestsTable/>
                    ) : (
                        <div className="p-card p-component p-4 text-center">
                            <i className="pi pi-lock text-danger" style={{fontSize: '3rem'}}></i>
                            <h2 className="mt-3 text-danger">403 - Forbidden</h2>
                            <p className="mt-2 text-muted">You do not have the required permissions to access this
                                page.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default BeneficiaryRequestsPage;
